
import { createSlice } from "@reduxjs/toolkit";

const KidAuthSlice = createSlice({
  name: "parentKidAuth",
  initialState: {
    parentKidUser: null,
    loading: false,
    error: null,
    
  },
  reducers: {
    loginKidRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    loginKidSuccess: (state, action) => {
      state.loading = false;
      state.parentKidUser = action.payload;
    },
    loginKidFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    KidLogout: (state) => {
      state.parentKidUser = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { loginKidRequest, loginKidSuccess, loginKidFailure, KidLogout } = KidAuthSlice.actions;
export default KidAuthSlice.reducer;
